<template>
  <main
    class="main animated fadeIn faster"
    :class="{ 'expand-main': isMenuCollapse }"
  >
    <div class="row mx-1" v-if="isBdrUser(['Screening']) || isBdrUser(['Outdated'])">
      <!-- Header -->
      <div class="col-12 text-center header-bg">
        <img
          src="@/assets/images/booker/booker_merci.png"
          alt="merci_booker"
          class="img-fluid d-none d-sm-block mx-auto"
        />

        <img
          src="@/assets/images/booker/booker_merci.png"
          alt="merci_booker"
          class="img-fluid d-sm-none"
          style="width: 50%"
        />
      </div>

      <!-- Content -->
      <div class="col-12 text-center">
        <div class="mt-4">
          <img
            src="@/assets/images/booker/booker_merci_hubert.png"
            alt="merci_booker"
            width="460px"
            class="d-none d-sm-block mx-auto"
          />
          <img
            src="@/assets/images/booker/booker_merci_hubert.png"
            alt="merci_booker"
            class="img-fluid d-sm-none"
            style="width: 50%"
          />

          <!-- <img src="@/assets/images/booker/booker_merci_hubert.png" alt="merci_booker" width="460px"> -->
          <p class="h3 mt-4 mb-4">
            {{ $t("lang.label.merci_hubert_welcome") }}
          </p>
        </div>
        <div class="row">
          <div class="offset-md-2 col-md-10 col-lg-8 col-xl-6 mx-auto">
            <p class="h6 my-3">
              {{ $t("lang.label.merci_hubert_thanks_to_create") }}
            </p>
            <p class="h6">
              {{ $t("lang.label.merci_hubert_profile_valid") }}
            </p>
          </div>
        </div>
      </div>

      <!-- button to link -->
      <div class="col-12 text-center mt-4">
        <a
          class="btn btn-lg px-5 py-3 text-dark rounded-2 bt-bg"
          href="https://www.videoask.com/fxe1dbd84"
          target="_blank"
          rel="noopener noreferrer"
        >
          {{ $t("lang.label.merci_hubert_button") }}
        </a>
      </div>
    </div>

    <!-- View for the bookers with status Rejected trial and interview -->
    <div class="row mx-1 mt-5" v-if="isBdrUser(['Rejected (interview)', 'Rejected (trial)'])">
      <div class="col-md-12 text-center">
        <div class="mt-4">
          <p class="h1 mt-4 mb-4 font-weight-bold">
            {{$t("lang.label.booker_rejected_tittle")}} 🙏
          </p>
        </div>
        <div class="row text-justify">
          <div class="offset-md-2 col-md-10 col-lg-8 col-xl-6 mx-auto">
            <p class="h5 my-3">
              {{$t("lang.label.hello")}},
            </p>
            <p class="h5">
              {{$t("lang.label.booker_rejected_p1")}}
            </p>
            <p class="h5">
              {{$t("lang.label.booker_rejected_p2")}}
            </p>
            <p class="h5">
              {{$t("lang.label.booker_rejected_p3")}}
            </p>
            <p class="h5">
              {{$t("lang.label.booker_rejected_p4")}}
            </p>
            <p class="h5">
              {{$t("lang.label.goodbye")}},
            </p>
            <p class="h5 font-weight-bold">
              {{$t("lang.label.recruitment_team")}} – Merci Hubert
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- View for the bookers with status Stopped -->
    <div class="row mx-1 mt-5" v-if="isBdrUser(['Stopped'])">
      <div class="col-md-12 text-center">
        <div class="mt-4">
          <p class="h1 mt-4 mb-4 font-weight-bold">
            {{ $t("lang.label.booker_stopped_tittle") }}
          </p>
        </div>
        <div class="row text-justify">
          <div class="offset-md-2 col-md-10 col-lg-8 col-xl-7 mx-auto">
            <p class="h5 mb-4">
              {{ $t("lang.label.booker_stopped_p1") }}
            </p>
            <p class="h5 mb-4">
              {{ $t("lang.label.booker_stopped_p2") }}
            </p>
            <p class="h5 mb-4">
              {{ $t("lang.label.booker_stopped_p3") }}
            </p>
            <p class="h5 mb-4">
              {{ $t("lang.label.team_merci_hubert") }}
            </p>
            <hr>
            <p class="h4 font-weight-bold">
              {{$t("lang.label.recruitment_team")}} – Merci Hubert
            </p>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "BookerMerciHubert",
  props: {},
  data() {
    return {
      exampleData: "",
    };
  },
  computed: {
    ...mapState({
      headerTab: (state) => state.header.tab,
      isMenuCollapse: (state) => state.sidebar.isNavOpen,
    }),
    user() {
      return this.$store.state.authentication.user;
    },
    isBdrUser() {
      return (status) => {
        if (status) {
          if (
            this.user.team_role_id == 2 &&
            this.user.role_id == 2 &&
            status.includes(this.user.booker.status)
          ) {
            return true;
          }
        }
        return false;
      };
    },
  },
  methods: {},
};
</script>

<style scoped>
.bt-bg {
  background: #f3d68c;
}

.header-bg {
  background: #ff9aa2;
}
</style>
